import React from "react";
import AudioPlayer from "./AudioPlayer";

import "../styles/ResultScreen.css";

function ResultScreen({ result, originalName, onRestart }) {
  const downloadFile = (url, filename) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <>
    <div className="containerResult">
      <div className="textResult">
        <h1 className="titulo">Separação concluída!</h1>
        <p className="subtitulo">Ouça os resultados e baixe ao lado:</p>
        <h4>Nota estimada: {result.key}</h4>
        <h5> *Acertividade 12.4%</h5>

      </div>

      <div className="buttonsResult">
        <div style={{ marginTop: "0px" }}>
          <h3
            style={{
              color: "var(--branco)",
              textAlign: "start",
              fontWeight: "400",
            }}
          >
            Vocal:
          </h3>
          <AudioPlayer src={result.vocalsUrl} />
          <button
            style={{ marginTop: "10px" }}
            onClick={() =>
              downloadFile(result.vocalsUrl, `${originalName}_vocal.wav`)
            }
          >
            Download Vocal
          </button>
        </div>

        <div style={{ marginTop: "10px" }}>
          <h3
            style={{
              color: "var(--branco)",
              textAlign: "start",
              fontWeight: "400",
              marginTop: "20px",
            }}
          >
            Instrumental
          </h3>
          <AudioPlayer src={result.accompanimentUrl} />
          <button
            style={{ marginTop: "10px" }}
            onClick={() =>
              downloadFile(
                result.accompanimentUrl,
                `${originalName}_instrumental.wav`
              )
            }
          >
            Download Instrumental
          </button>
        </div>
      </div>
    </div>
    
    <button className="buttonNew" onClick={onRestart}>Separar outro áudio</button>
    </>
  );
}

export default ResultScreen;
